import React from 'react';
import PropTypes from 'prop-types';
import EditorUtils from '../../../draft-js-plugins-utils/src';
import { isBomBombVideoSelected } from './../../../draft-js-bombbomb-plugin/index';
import AddLinkForm from './AddLinkForm';

import linkifyIt from 'linkify-it';
import tlds from 'tlds';
import { Popup } from '$/components/ui/Popup';

const linkify = linkifyIt();
linkify.tlds(tlds);

const LinkButton = (props) => {
  const onMouseDown = (event) => {
    event.preventDefault();
  };

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const { ownTheme, placeholder, validateUrl, editorId, inStatic } = props;

    const linkInstance = EditorUtils.getCurrentEntity(props.store?.getEditorState?.());

    const url = linkInstance ? linkInstance.getData().url : '';

    const content = (contentProps) => {
      if (contentProps.toolbarContent) {
        return (
          <>
            {contentProps.toolbarContent}
            <AddLinkForm
              {...contentProps}
              inStatic={inStatic && !props.inlineToolBarRef?.current}
              placeholder={placeholder}
              value={url}
              theme={ownTheme}
              validateUrl={validateUrl}
              editorId={editorId}
            />
          </>
        );
      }
      return (
        <AddLinkForm
          {...contentProps}
          inStatic={inStatic && !props.inlineToolBarRef?.current}
          editorId={editorId}
          placeholder={placeholder}
          value={url}
          theme={ownTheme}
          validateUrl={validateUrl}
        />
      );
    };

    const onOverrideContent = props.inlineToolBarRef?.current?.onOverrideContent || props.onOverrideContent;
    onOverrideContent(content);
  };

  const { theme } = props;

  const editorState = props.store?.getEditorState?.();
  const linkInstance = EditorUtils.getCurrentEntity(editorState);
  const hasLinkSelected =
    editorState && linkInstance
      ? EditorUtils.hasEntity(editorState, 'LINK') ||
      Boolean(linkInstance && linkInstance.getData().url)
      : false;
  const isBombBombVideo = editorState ? isBomBombVideoSelected(editorState) : false;
  const isCTAButton = editorState ? EditorUtils.hasEntity(editorState, 'BUTTON') : false;

  const selection = editorState?.getSelection();
  const isVisible = !selection?.isCollapsed() && selection?.getHasFocus();

  let linkButtonStyle = theme.button;
  let buttonWrapper = props?.title ? [theme.buttonWrapper, theme.buttonGroup] : theme.buttonWrapper;
  // active link
  if (hasLinkSelected && !isBombBombVideo && !isCTAButton) {
    linkButtonStyle = [theme.button, theme.active];
    if (!props.inStatic) {
      buttonWrapper = [buttonWrapper, theme.active];
    }
  } else if (!isVisible) {
    buttonWrapper = [buttonWrapper, theme.inactive];
  }

  return (
    <div
      css={buttonWrapper}
      className={Boolean(props.linkToolbarDisabled) && 'hidden'}
      onMouseDown={onMouseDown}
    >
      <Popup
        content='Insert link'
        className='ml-0'
        hoverable
        trigger={
          <button
            css={linkButtonStyle}
            onClick={onClick}
            type='button'
          >
            <svg height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'>
              <path d='M0 0h24v24H0z' fill='none' />
              <path
                d='M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z'
                fill='currentColor'
              />
            </svg>
          </button>
        } />
      {props?.title && <span>{props.title}</span>}
    </div>
  );
};

LinkButton.propTypes = {
  placeholder: PropTypes.string,
  store: PropTypes.object.isRequired,
  ownTheme: PropTypes.object.isRequired,
  validateUrl: PropTypes.func,
  inStatic: PropTypes.bool,
  title: PropTypes.string,
  linkToolbarDisabled: PropTypes.bool,
  editorId: PropTypes.string,
};

export default LinkButton;
